import { defineComponent } from 'vue';
import { BlockModule } from '../common';
import { useShare } from '@vueuse/core';

new BlockModule({
    selector: '.block-native-share',
    vueComponent: defineComponent({
        name: 'block-native-share',
        setup() {
            const { share, isSupported } = useShare()

            const startShare = (title = '') => {
                share({
                    title,
                    url: window.location.href,
                })
            };

            return {
                startShare,
                isShareSupported: isSupported,
            }
        },
    }),
});
